export default __webpack_public_path__ + "static/8010-ec079039d4ae0ccf6d3219e92810d8b1.jpg";